/* tslint:disable */
/* eslint-disable */
/**
 * Flight Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddFlightSpecialOfferRequest } from '../model';
// @ts-ignore
import { AddFreeCargoLimitationRequest } from '../model';
// @ts-ignore
import { AircraftDto } from '../model';
// @ts-ignore
import { AirlineTypes } from '../model';
// @ts-ignore
import { AmazingOfferResponseDto } from '../model';
// @ts-ignore
import { CancellationTermsResponse } from '../model';
// @ts-ignore
import { GetBaggageInfoResponseDto } from '../model';
// @ts-ignore
import { GetCargoLimitationListResult } from '../model';
// @ts-ignore
import { GetFlightApproximatePriceResponse } from '../model';
// @ts-ignore
import { GetFlightInfoRequest } from '../model';
// @ts-ignore
import { GetFlightInfoResponse } from '../model';
// @ts-ignore
import { GetFlightSpecialOffersResponse } from '../model';
// @ts-ignore
import { GetFlightsRequestDto } from '../model';
// @ts-ignore
import { GetFlightsResponseDto } from '../model';
// @ts-ignore
import { GetFreeCargoLimitationListRequest } from '../model';
// @ts-ignore
import { MaxPriceResponseDto } from '../model';
// @ts-ignore
import { MinPriceRequest } from '../model';
// @ts-ignore
import { MinPriceResponseItem } from '../model';
// @ts-ignore
import { PriceLimitationDto } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { ReserveFlightRequest } from '../model';
// @ts-ignore
import { ReserveResponse } from '../model';
// @ts-ignore
import { UpdateFlightSpecialOfferRequest } from '../model';
// @ts-ignore
import { UpdateFlightsPricesRequest } from '../model';
// @ts-ignore
import { UpdateFreeCargoLimitationRequest } from '../model';
// @ts-ignore
import { UserRequestHeaders } from '../model';
/**
 * FlightsApiApiFlightsAddFreeCargoLimitationPost - axios parameter creator
 * 
 * @summary Add Free Cargo Limitation
 * @param {AddFreeCargoLimitationRequest} [addFreeCargoLimitationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsAddFreeCargoLimitationPostAxiosParamCreator (addFreeCargoLimitationRequest?: AddFreeCargoLimitationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/AddFreeCargoLimitation`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addFreeCargoLimitationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsAddSpecialOfferPost - axios parameter creator
 * 
 * @summary Add Special Offer with its items (Auth policies: Flight:AddFlightInfo)
 * @param {AddFlightSpecialOfferRequest} [addFlightSpecialOfferRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsAddSpecialOfferPostAxiosParamCreator (addFlightSpecialOfferRequest?: AddFlightSpecialOfferRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/AddSpecialOffer`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addFlightSpecialOfferRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsAircraftsGet - axios parameter creator
 * 
 * @summary Get Aircraft List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsAircraftsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/Aircrafts`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsAmazingOffsGet - axios parameter creator
 * 
 * @summary دریافت لیست پیشنهادات ویژه و شگفت انگیز پرواز
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsAmazingOffsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/AmazingOffs`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsCancellationTermsProposalIdGet - axios parameter creator
 * 
 * @summary دریافت متن شرایط و مقررات کنسلی برای یک پرواز (Auth policies: Flight:GetFlightInfo)
 * @param {string} proposalId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsCancellationTermsProposalIdGetAxiosParamCreator (proposalId: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'proposalId' is not null or undefined
    assertParamExists('apiFlightsCancellationTermsProposalIdGet', 'proposalId', proposalId)
    const localVarPath = `/api/Flights/CancellationTerms/{proposalId}`
        .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsCheckAvailableGet - axios parameter creator
 * 
 * @summary این اند پوینت برای وبینگیج نوشته شده ک چک میکنه یک مسیر در یک تاریخ موجودی داره یا خیر
 * @param {string} [fromCode] 
 * @param {string} [toCode] 
 * @param {string} [date] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsCheckAvailableGetAxiosParamCreator (fromCode?: string, toCode?: string, date?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/CheckAvailable`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fromCode !== undefined) {
        localVarQueryParameter['fromCode'] = fromCode;
    }

    if (toCode !== undefined) {
        localVarQueryParameter['toCode'] = toCode;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDelete - axios parameter creator
 * 
 * @summary Delete FreeCargo Limitation (Auth policies: Flight:DeleteFlightInfo)
 * @param {number} freeCargoLimitationId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDeleteAxiosParamCreator (freeCargoLimitationId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'freeCargoLimitationId' is not null or undefined
    assertParamExists('apiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDelete', 'freeCargoLimitationId', freeCargoLimitationId)
    const localVarPath = `/api/Flights/DeleteFreeCargoLimitation/{freeCargoLimitationId}`
        .replace(`{${"freeCargoLimitationId"}}`, encodeURIComponent(String(freeCargoLimitationId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsDeleteSpecialOfferDelete - axios parameter creator
 * 
 * @summary Delete Special Offer with its items (Auth policies: Flight:DeleteFlightInfo)
 * @param {number} [specialOfferId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsDeleteSpecialOfferDeleteAxiosParamCreator (specialOfferId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/DeleteSpecialOffer`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (specialOfferId !== undefined) {
        localVarQueryParameter['specialOfferId'] = specialOfferId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsFareFamilyGet - axios parameter creator
 * 
 * @summary این اند پونت صرفا برای پروایدر پرتو کاربرد دارد که یکسری اطلاعات رو در صفحه ی ریز نشون میده که این اطلاعات رو فقط پرتو داره بهمون میده
 * @param {string} [proposalId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsFareFamilyGetAxiosParamCreator (proposalId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/FareFamily`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (proposalId !== undefined) {
        localVarQueryParameter['proposalId'] = proposalId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsFlightByNumberPost - axios parameter creator
 * 
 * @summary Get flight information with flightId and date
 * @param {GetFlightInfoRequest} [getFlightInfoRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsFlightByNumberPostAxiosParamCreator (getFlightInfoRequest?: GetFlightInfoRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/FlightByNumber`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getFlightInfoRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGenerateAmazingOffPost - axios parameter creator
 * 
 * @summary ساخت لیست پروازهای شگفت انگیز و کش کردنش (Auth policies: Flight:GetFlightInfo)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGenerateAmazingOffPostAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GenerateAmazingOff`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGetAllPriceLimitationsGet - axios parameter creator
 * 
 * @summary دریافت لیست تمام سقف های نرخی
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGetAllPriceLimitationsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GetAllPriceLimitations`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGetBaggageInfoPost - axios parameter creator
 * 
 * @param {string} [proposalId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGetBaggageInfoPostAxiosParamCreator (proposalId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GetBaggageInfo`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (proposalId !== undefined) {
        localVarQueryParameter['proposalId'] = proposalId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGetCargoLimitationListPost - axios parameter creator
 * 
 * @summary Get Cargo Limitation List
 * @param {GetFreeCargoLimitationListRequest} [getFreeCargoLimitationListRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGetCargoLimitationListPostAxiosParamCreator (getFreeCargoLimitationListRequest?: GetFreeCargoLimitationListRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GetCargoLimitationList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getFreeCargoLimitationListRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGetFlightApproximatePriceGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGetFlightApproximatePriceGetAxiosParamCreator (from?: string, to?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GetFlightApproximatePrice`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [days] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGetAxiosParamCreator (from?: string, to?: string, days?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GetFlightMinPriceInLastNDays`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (days !== undefined) {
        localVarQueryParameter['days'] = days;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsGetMaxPriceGet - axios parameter creator
 * 
 * @summary دریافت سقف قیمتی یک مسیر
 * @param {string} [fromCode] 
 * @param {string} [toCode] 
 * @param {string} [date] 
 * @param {AirlineTypes} [airlineTypes] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsGetMaxPriceGetAxiosParamCreator (fromCode?: string, toCode?: string, date?: string, airlineTypes?: AirlineTypes, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/GetMaxPrice`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fromCode !== undefined) {
        localVarQueryParameter['fromCode'] = fromCode;
    }

    if (toCode !== undefined) {
        localVarQueryParameter['toCode'] = toCode;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (airlineTypes !== undefined) {
        localVarQueryParameter['airlineTypes'] = airlineTypes;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsMinPricesPost - axios parameter creator
 * 
 * @summary دریافت تقویم قیمتی
 * @param {MinPriceRequest} [minPriceRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsMinPricesPostAxiosParamCreator (minPriceRequest?: MinPriceRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/MinPrices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(minPriceRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsPost - axios parameter creator
 * 
 * @summary دریافت لیست موجودی پرواز ها که منسوخ شده است و از اند پوینتی که داخل هاب هست استفاده میشه
 * @param {GetFlightsRequestDto} [getFlightsRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsPostAxiosParamCreator (getFlightsRequestDto?: GetFlightsRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getFlightsRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsReservePost - axios parameter creator
 * 
 * @param {UserRequestHeaders} [requestHeaders] 
 * @param {ReserveFlightRequest} [reserveFlightRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsReservePostAxiosParamCreator (requestHeaders?: UserRequestHeaders, reserveFlightRequest?: ReserveFlightRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/Reserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (requestHeaders != null) {
        localVarHeaderParameter['requestHeaders'] = typeof requestHeaders === 'string'
            ? requestHeaders
            : JSON.stringify(requestHeaders);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(reserveFlightRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsSpecialOfferListGet - axios parameter creator
 * 
 * @summary Get Fight Special Offer List (Auth policies: Flight:GetFlightInfo)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsSpecialOfferListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/SpecialOfferList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsUpdateFlightsByIdPost - axios parameter creator
 * 
 * @summary update Flight
 * @param {UpdateFlightsPricesRequest} [updateFlightsPricesRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsUpdateFlightsByIdPostAxiosParamCreator (updateFlightsPricesRequest?: UpdateFlightsPricesRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/UpdateFlightsById`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateFlightsPricesRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsUpdateFreeCargoLimitationPut - axios parameter creator
 * 
 * @summary Update Free Cargo Limitation
 * @param {UpdateFreeCargoLimitationRequest} [updateFreeCargoLimitationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsUpdateFreeCargoLimitationPutAxiosParamCreator (updateFreeCargoLimitationRequest?: UpdateFreeCargoLimitationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/UpdateFreeCargoLimitation`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateFreeCargoLimitationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsUpdatePriceLimitationsPost - axios parameter creator
 * 
 * @summary آپدیت کردن سقف های نرخی (Auth policies: Flight:UpdatePriceLimitations)
 * @param {Array<PriceLimitationDto>} [priceLimitationDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsUpdatePriceLimitationsPostAxiosParamCreator (priceLimitationDto?: Array<PriceLimitationDto>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/UpdatePriceLimitations`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(priceLimitationDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FlightsApiApiFlightsUpdateSpecialOfferPut - axios parameter creator
 * 
 * @summary update Special Offer with its items (Auth policies: Flight:UpdateFlightInfo)
 * @param {UpdateFlightSpecialOfferRequest} [updateFlightSpecialOfferRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FlightsApiApiFlightsUpdateSpecialOfferPutAxiosParamCreator (updateFlightSpecialOfferRequest?: UpdateFlightSpecialOfferRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Flights/UpdateSpecialOffer`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateFlightSpecialOfferRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiFlightsAddFreeCargoLimitationPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsAddFreeCargoLimitationPostRequest
 */
export interface FlightsApiApiFlightsAddFreeCargoLimitationPostRequest {
    /**
     * 
     * @type {AddFreeCargoLimitationRequest}
     * @memberof FlightsApiApiFlightsAddFreeCargoLimitationPost
     */
    readonly addFreeCargoLimitationRequest?: AddFreeCargoLimitationRequest
}

/**
 * Request parameters for apiFlightsAddSpecialOfferPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsAddSpecialOfferPostRequest
 */
export interface FlightsApiApiFlightsAddSpecialOfferPostRequest {
    /**
     * 
     * @type {AddFlightSpecialOfferRequest}
     * @memberof FlightsApiApiFlightsAddSpecialOfferPost
     */
    readonly addFlightSpecialOfferRequest?: AddFlightSpecialOfferRequest
}

/**
 * Request parameters for apiFlightsCancellationTermsProposalIdGet operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsCancellationTermsProposalIdGetRequest
 */
export interface FlightsApiApiFlightsCancellationTermsProposalIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsCancellationTermsProposalIdGet
     */
    readonly proposalId: string
}

/**
 * Request parameters for apiFlightsCheckAvailableGet operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsCheckAvailableGetRequest
 */
export interface FlightsApiApiFlightsCheckAvailableGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsCheckAvailableGet
     */
    readonly fromCode?: string

    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsCheckAvailableGet
     */
    readonly toCode?: string

    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsCheckAvailableGet
     */
    readonly date?: string
}

/**
 * Request parameters for apiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDelete operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDeleteRequest
 */
export interface FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDelete
     */
    readonly freeCargoLimitationId: number
}

/**
 * Request parameters for apiFlightsDeleteSpecialOfferDelete operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsDeleteSpecialOfferDeleteRequest
 */
export interface FlightsApiApiFlightsDeleteSpecialOfferDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof FlightsApiApiFlightsDeleteSpecialOfferDelete
     */
    readonly specialOfferId?: number
}

/**
 * Request parameters for apiFlightsFareFamilyGet operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsFareFamilyGetRequest
 */
export interface FlightsApiApiFlightsFareFamilyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsFareFamilyGet
     */
    readonly proposalId?: string
}

/**
 * Request parameters for apiFlightsFlightByNumberPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsFlightByNumberPostRequest
 */
export interface FlightsApiApiFlightsFlightByNumberPostRequest {
    /**
     * 
     * @type {GetFlightInfoRequest}
     * @memberof FlightsApiApiFlightsFlightByNumberPost
     */
    readonly getFlightInfoRequest?: GetFlightInfoRequest
}

/**
 * Request parameters for apiFlightsGetBaggageInfoPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsGetBaggageInfoPostRequest
 */
export interface FlightsApiApiFlightsGetBaggageInfoPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetBaggageInfoPost
     */
    readonly proposalId?: string
}

/**
 * Request parameters for apiFlightsGetCargoLimitationListPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsGetCargoLimitationListPostRequest
 */
export interface FlightsApiApiFlightsGetCargoLimitationListPostRequest {
    /**
     * 
     * @type {GetFreeCargoLimitationListRequest}
     * @memberof FlightsApiApiFlightsGetCargoLimitationListPost
     */
    readonly getFreeCargoLimitationListRequest?: GetFreeCargoLimitationListRequest
}

/**
 * Request parameters for apiFlightsGetFlightApproximatePriceGet operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsGetFlightApproximatePriceGetRequest
 */
export interface FlightsApiApiFlightsGetFlightApproximatePriceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetFlightApproximatePriceGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetFlightApproximatePriceGet
     */
    readonly to?: string
}

/**
 * Request parameters for apiFlightsGetFlightMinPriceInLastNDaysGet operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGetRequest
 */
export interface FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGet
     */
    readonly days?: number
}

/**
 * Request parameters for apiFlightsGetMaxPriceGet operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsGetMaxPriceGetRequest
 */
export interface FlightsApiApiFlightsGetMaxPriceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetMaxPriceGet
     */
    readonly fromCode?: string

    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetMaxPriceGet
     */
    readonly toCode?: string

    /**
     * 
     * @type {string}
     * @memberof FlightsApiApiFlightsGetMaxPriceGet
     */
    readonly date?: string

    /**
     * 
     * @type {AirlineTypes}
     * @memberof FlightsApiApiFlightsGetMaxPriceGet
     */
    readonly airlineTypes?: AirlineTypes
}

/**
 * Request parameters for apiFlightsMinPricesPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsMinPricesPostRequest
 */
export interface FlightsApiApiFlightsMinPricesPostRequest {
    /**
     * 
     * @type {MinPriceRequest}
     * @memberof FlightsApiApiFlightsMinPricesPost
     */
    readonly minPriceRequest?: MinPriceRequest
}

/**
 * Request parameters for apiFlightsPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsPostRequest
 */
export interface FlightsApiApiFlightsPostRequest {
    /**
     * 
     * @type {GetFlightsRequestDto}
     * @memberof FlightsApiApiFlightsPost
     */
    readonly getFlightsRequestDto?: GetFlightsRequestDto
}

/**
 * Request parameters for apiFlightsReservePost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsReservePostRequest
 */
export interface FlightsApiApiFlightsReservePostRequest {
    /**
     * 
     * @type {UserRequestHeaders}
     * @memberof FlightsApiApiFlightsReservePost
     */
    readonly requestHeaders?: UserRequestHeaders

    /**
     * 
     * @type {ReserveFlightRequest}
     * @memberof FlightsApiApiFlightsReservePost
     */
    readonly reserveFlightRequest?: ReserveFlightRequest
}

/**
 * Request parameters for apiFlightsUpdateFlightsByIdPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsUpdateFlightsByIdPostRequest
 */
export interface FlightsApiApiFlightsUpdateFlightsByIdPostRequest {
    /**
     * 
     * @type {UpdateFlightsPricesRequest}
     * @memberof FlightsApiApiFlightsUpdateFlightsByIdPost
     */
    readonly updateFlightsPricesRequest?: UpdateFlightsPricesRequest
}

/**
 * Request parameters for apiFlightsUpdateFreeCargoLimitationPut operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsUpdateFreeCargoLimitationPutRequest
 */
export interface FlightsApiApiFlightsUpdateFreeCargoLimitationPutRequest {
    /**
     * 
     * @type {UpdateFreeCargoLimitationRequest}
     * @memberof FlightsApiApiFlightsUpdateFreeCargoLimitationPut
     */
    readonly updateFreeCargoLimitationRequest?: UpdateFreeCargoLimitationRequest
}

/**
 * Request parameters for apiFlightsUpdatePriceLimitationsPost operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsUpdatePriceLimitationsPostRequest
 */
export interface FlightsApiApiFlightsUpdatePriceLimitationsPostRequest {
    /**
     * 
     * @type {Array<PriceLimitationDto>}
     * @memberof FlightsApiApiFlightsUpdatePriceLimitationsPost
     */
    readonly priceLimitationDto?: Array<PriceLimitationDto>
}

/**
 * Request parameters for apiFlightsUpdateSpecialOfferPut operation in FlightsApi.
 * @export
 * @interface FlightsApiApiFlightsUpdateSpecialOfferPutRequest
 */
export interface FlightsApiApiFlightsUpdateSpecialOfferPutRequest {
    /**
     * 
     * @type {UpdateFlightSpecialOfferRequest}
     * @memberof FlightsApiApiFlightsUpdateSpecialOfferPut
     */
    readonly updateFlightSpecialOfferRequest?: UpdateFlightSpecialOfferRequest
}

/**
* 
* @summary Add Free Cargo Limitation
* @param {FlightsApiApiFlightsAddFreeCargoLimitationPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsAddFreeCargoLimitationPost(requestParameters: FlightsApiApiFlightsAddFreeCargoLimitationPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsAddFreeCargoLimitationPostAxiosParamCreator(requestParameters.addFreeCargoLimitationRequest, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Add Special Offer with its items (Auth policies: Flight:AddFlightInfo)
* @param {FlightsApiApiFlightsAddSpecialOfferPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsAddSpecialOfferPost(requestParameters: FlightsApiApiFlightsAddSpecialOfferPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsAddSpecialOfferPostAxiosParamCreator(requestParameters.addFlightSpecialOfferRequest, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Aircraft List
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsAircraftsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsAircraftsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<AircraftDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست پیشنهادات ویژه و شگفت انگیز پرواز
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsAmazingOffsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsAmazingOffsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AmazingOfferResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت متن شرایط و مقررات کنسلی برای یک پرواز (Auth policies: Flight:GetFlightInfo)
* @param {FlightsApiApiFlightsCancellationTermsProposalIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsCancellationTermsProposalIdGet(requestParameters: FlightsApiApiFlightsCancellationTermsProposalIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsCancellationTermsProposalIdGetAxiosParamCreator(requestParameters.proposalId, options, configuration);
    const request: () => AxiosPromise<CancellationTermsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary این اند پوینت برای وبینگیج نوشته شده ک چک میکنه یک مسیر در یک تاریخ موجودی داره یا خیر
* @param {FlightsApiApiFlightsCheckAvailableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsCheckAvailableGet(requestParameters: FlightsApiApiFlightsCheckAvailableGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsCheckAvailableGetAxiosParamCreator(requestParameters.fromCode, requestParameters.toCode, requestParameters.date, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Delete FreeCargo Limitation (Auth policies: Flight:DeleteFlightInfo)
* @param {FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDelete(requestParameters: FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsDeleteFreeCargoLimitationFreeCargoLimitationIdDeleteAxiosParamCreator(requestParameters.freeCargoLimitationId, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Delete Special Offer with its items (Auth policies: Flight:DeleteFlightInfo)
* @param {FlightsApiApiFlightsDeleteSpecialOfferDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsDeleteSpecialOfferDelete(requestParameters: FlightsApiApiFlightsDeleteSpecialOfferDeleteRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsDeleteSpecialOfferDeleteAxiosParamCreator(requestParameters.specialOfferId, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary این اند پونت صرفا برای پروایدر پرتو کاربرد دارد که یکسری اطلاعات رو در صفحه ی ریز نشون میده که این اطلاعات رو فقط پرتو داره بهمون میده
* @param {FlightsApiApiFlightsFareFamilyGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsFareFamilyGet(requestParameters: FlightsApiApiFlightsFareFamilyGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsFareFamilyGetAxiosParamCreator(requestParameters.proposalId, options, configuration);
    const request: () => AxiosPromise<GetFlightsResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get flight information with flightId and date
* @param {FlightsApiApiFlightsFlightByNumberPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsFlightByNumberPost(requestParameters: FlightsApiApiFlightsFlightByNumberPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsFlightByNumberPostAxiosParamCreator(requestParameters.getFlightInfoRequest, options, configuration);
    const request: () => AxiosPromise<Array<GetFlightInfoResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary ساخت لیست پروازهای شگفت انگیز و کش کردنش (Auth policies: Flight:GetFlightInfo)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGenerateAmazingOffPost(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGenerateAmazingOffPostAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست تمام سقف های نرخی
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGetAllPriceLimitationsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGetAllPriceLimitationsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<MaxPriceResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {FlightsApiApiFlightsGetBaggageInfoPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGetBaggageInfoPost(requestParameters: FlightsApiApiFlightsGetBaggageInfoPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGetBaggageInfoPostAxiosParamCreator(requestParameters.proposalId, options, configuration);
    const request: () => AxiosPromise<GetBaggageInfoResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Cargo Limitation List
* @param {FlightsApiApiFlightsGetCargoLimitationListPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGetCargoLimitationListPost(requestParameters: FlightsApiApiFlightsGetCargoLimitationListPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGetCargoLimitationListPostAxiosParamCreator(requestParameters.getFreeCargoLimitationListRequest, options, configuration);
    const request: () => AxiosPromise<Array<GetCargoLimitationListResult>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {FlightsApiApiFlightsGetFlightApproximatePriceGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGetFlightApproximatePriceGet(requestParameters: FlightsApiApiFlightsGetFlightApproximatePriceGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGetFlightApproximatePriceGetAxiosParamCreator(requestParameters.from, requestParameters.to, options, configuration);
    const request: () => AxiosPromise<GetFlightApproximatePriceResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGet(requestParameters: FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGetFlightMinPriceInLastNDaysGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.days, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت سقف قیمتی یک مسیر
* @param {FlightsApiApiFlightsGetMaxPriceGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsGetMaxPriceGet(requestParameters: FlightsApiApiFlightsGetMaxPriceGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsGetMaxPriceGetAxiosParamCreator(requestParameters.fromCode, requestParameters.toCode, requestParameters.date, requestParameters.airlineTypes, options, configuration);
    const request: () => AxiosPromise<MaxPriceResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت تقویم قیمتی
* @param {FlightsApiApiFlightsMinPricesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsMinPricesPost(requestParameters: FlightsApiApiFlightsMinPricesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsMinPricesPostAxiosParamCreator(requestParameters.minPriceRequest, options, configuration);
    const request: () => AxiosPromise<Array<MinPriceResponseItem>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست موجودی پرواز ها که منسوخ شده است و از اند پوینتی که داخل هاب هست استفاده میشه
* @param {FlightsApiApiFlightsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsPost(requestParameters: FlightsApiApiFlightsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsPostAxiosParamCreator(requestParameters.getFlightsRequestDto, options, configuration);
    const request: () => AxiosPromise<GetFlightsResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {FlightsApiApiFlightsReservePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsReservePost(requestParameters: FlightsApiApiFlightsReservePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsReservePostAxiosParamCreator(requestParameters.requestHeaders, requestParameters.reserveFlightRequest, options, configuration);
    const request: () => AxiosPromise<ReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Fight Special Offer List (Auth policies: Flight:GetFlightInfo)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsSpecialOfferListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsSpecialOfferListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<GetFlightSpecialOffersResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary update Flight
* @param {FlightsApiApiFlightsUpdateFlightsByIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsUpdateFlightsByIdPost(requestParameters: FlightsApiApiFlightsUpdateFlightsByIdPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsUpdateFlightsByIdPostAxiosParamCreator(requestParameters.updateFlightsPricesRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Update Free Cargo Limitation
* @param {FlightsApiApiFlightsUpdateFreeCargoLimitationPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsUpdateFreeCargoLimitationPut(requestParameters: FlightsApiApiFlightsUpdateFreeCargoLimitationPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsUpdateFreeCargoLimitationPutAxiosParamCreator(requestParameters.updateFreeCargoLimitationRequest, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary آپدیت کردن سقف های نرخی (Auth policies: Flight:UpdatePriceLimitations)
* @param {FlightsApiApiFlightsUpdatePriceLimitationsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsUpdatePriceLimitationsPost(requestParameters: FlightsApiApiFlightsUpdatePriceLimitationsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsUpdatePriceLimitationsPostAxiosParamCreator(requestParameters.priceLimitationDto, options, configuration);
    const request: () => AxiosPromise<MaxPriceResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary update Special Offer with its items (Auth policies: Flight:UpdateFlightInfo)
* @param {FlightsApiApiFlightsUpdateSpecialOfferPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FlightsApiApiFlightsUpdateSpecialOfferPut(requestParameters: FlightsApiApiFlightsUpdateSpecialOfferPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FlightsApiApiFlightsUpdateSpecialOfferPutAxiosParamCreator(requestParameters.updateFlightSpecialOfferRequest, options, configuration);
    const request: () => AxiosPromise<object> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
